import { createRestSlice } from "./restSlice";

export type Environment = {
  id: string;
  organizationId: string;
  name: string;
  description: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
};

const environmentSlice = createRestSlice<Environment>("environment", "/v1/environments");

export const environmentReducer = environmentSlice.reducer;
export const environmentActions = environmentSlice.actions;
